export default __webpack_public_path__ + "static/media/1.df28694e.svg";